import React from "react";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000";

function InvestmentsIndexPage({ data }) {

    return (
        <div className="investments-index-page container-fluid">
            {data.logo && (
                <div className="logo mb-4">
                    <img src={data.logo.url} alt={data.logo.alt} />
                </div>
            )}

            {data.investments && data.investments.length > 0 ? (
                <div className="investments-list row w-100 mx-auto">
                    {data.investments.map((investment) => (
                        <div className="investment-card col-12 mb-80 bgwhite">
                            <div className="row p-80">
                                <div key={investment.id} className="col-lg-6 content-l">
                                    {investment.company_logo && (
                                        <div className="logo mb-48">
                                            <img
                                                src={investment.company_logo.original}
                                                alt={investment.company_logo.alt}
                                            />
                                        </div>
                                    )}
                                    <h3 className="mb-48" key={investment.id} dangerouslySetInnerHTML={{ __html: investment.custom_title }} />
                                    {investment.body.map((block) => {
                                        if (block.type === "rich_text") {
                                            return (
                                                <p
                                                    className="p-body-1"
                                                    key={block.id}
                                                    dangerouslySetInnerHTML={{ __html: block.value }}
                                                />
                                            );
                                        }
                                        return null;
                                    })}
                                </div>
                                {investment.partner_img && (
                                    <div className="col-lg-6 content-r">
                                        <div className="partner-img h-100">
                                            <img
                                                src={investment.partner_img.investment_page_image}
                                                alt={investment.partner_img.alt}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="row bottom-row">
                                <div className="col-12">
                                    <div className="investment-body">
                                        {investment.body.map((block) => {
                                            if (block.type === "data" && Array.isArray(block.value)) {
                                                return (
                                                    <div key={block.id} className="d-md-flex justify-content-between">
                                                        {block.value.map((item) => (
                                                            <div key={item.id} className="data-item">
                                                                <span className="number font-suisse-thin d-block">{item.value.value}</span>
                                                                <span className="text font-suisse-thin d-block">{item.value.title}</span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                );
                                            }
                                            return null;
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <p>No investments found.</p>
            )}

        </div>
    );
}

export default InvestmentsIndexPage;
